import request from '@/utils/request'
export function listCourse(params) {
    return request({
        url: 'business/course/listCourse',
        method: 'get',
        params
    })
}
export function getWebListProfession() {
    return request({
        url: '/business/profession/webList',
        method: 'get',
    })
}
export function getWebListCourse(params) {
    return request({
        url: '/business/course/webList',
        method: 'get',
        params
    })
}

// 查询PC端搜索历史列表
export function listSearchHistory(query) {
  return request({
    url: '/business/searchHistory/list',
    method: 'get',
    params: query
  })
}

// 查询PC端搜索历史详细
export function getSearchHistory(id) {
  return request({
    url: '/business/searchHistory/' + id,
    method: 'get'
  })
}

// 新增PC端搜索历史
export function addSearchHistory(data) {
  return request({
    url: '/business/searchHistory',
    method: 'post',
    data: data
  })
}

// 修改PC端搜索历史
export function updateSearchHistory(data) {
  return request({
    url: '/business/searchHistory',
    method: 'put',
    data: data
  })
}

// 删除PC端搜索历史
export function delSearchHistory(id) {
  return request({
    url: '/business/searchHistory/' + id,
    method: 'delete'
  })
}

//获取老师
export function getTeacherList(params) {
    return request({
        url: '/business/lecturer/list',
        method: 'get',
        params,
        header: {
            isToken: false
        }
    })
}
// 公开课
export function publicCourse(params){
	return request({
		url:'business/publicCourse/webList',
        method:'post',
        params,
	})
}
//职业课程访问量
export function postbrowse(data){
	return request({
		url:'business/access/insertTrainingCourseAccess',
        method:'post',
        data
	})
}
//素材库访问量
export function postmeatil(data){
	return request({
		url:'business/resourceaccess/insertTrainingResourceAccess',
        method:'post',
        data
	})
}
// 课程统计
export function pcCount(data){
	return request({
		url:'index/pcCount',
        method:'get'
	})
}
// 获取特色案例
export function featuredCase(data){
	return request({
		url:'business/menu/featuredCase',
        method:'get'
	})
}
//  专家风采
export function expertList(){
	return request({
		url:'business/expert/list',
        method:'get',
        params:{
            isHide:0
        }
	})
}

// 校企共育
export function cobreedingList(){
	return request({
		url:'business/cobreeding/list',
        method:'get',
        params:{
            isHide:0
        }
	})
}

// 合作院校
export function partnerList(params){
	return request({
		url:'business/partner/list',
        method:'get',
        params
	})
}
// /
export function getcobreeding(id){
	return request({
		url:'business/cobreeding/'+id,
        method:'get'
	})
}
//
export function getpartner(id){
	return request({
		url:'business/partner/'+id,
        method:'get'
	})
}
// 获取网站信息
export function getWebsiteConfigInfo() {
  return request({
    url: '/business/website/config/info',
    method:'get',
  })
}
// 获取轮播图列表
export function getCarouselList(query) {
  return request({
    url: '/business/carousel/getList',
    method:'get',
    params: query
  })
}

